import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/// COMPONENTES
import { ConfigComponent } from './configuracion/config.component';
import { EditN35Component } from './edit-n35/edit-n35.component';

import { UploadDBComponent } from './configuracion/uploaddb/uploaddb.component';
import { UploadLogoComponent } from './configuracion/uploadlogo/uploadlogo.component';
import { UploadFileComponent } from './configuracion/uploadfile/uploadfile.component';

import { GestUsuComponent } from './tools/gestUsu/gestUsu.component';
import { ODSComponent } from './tools/gestUsu/ods/ods.component';
import { EditComponent } from './tools/gestUsu/edit/edit.component';
import { TableODSComponent } from './tools/gestUsu/tableods/tableods.component';
import { TableodsV2Component } from './tools/gestUsu/tableods-v2/tableods-v2.component';
import { CreateComponent } from './tools/templatescreate/create.component';
import { DetailComponent } from './tools/gestUsu/detail/detail.component';
import { VisorCorreosComponent } from './tools/gestUsu/detail/visor-correos/visor-correos.component';
import { ControlEncuestasComponent } from './tools/gestUsu/detail/control-encuestas/control-encuestas.component';
import { PreviewEncuestasComponent } from './tools/gestUsu/detail/control-encuestas/preview-encuestas/preview-encuestas.component';
import { RegisterUserComponent } from './tools/gestUsu/registeruser/registeruser.component';
import { PaqueteComponent } from './tools/gestUsu/paquete/paquete.component';

import { NoProductoComponent } from './landingPages/noProd/noProd.component';
import { CardedFullWidth2Component } from './carded/full-width-2.component';

import { RequirementsComponent } from './tools/requirements/requirements.component';
import { DetailRequirementsComponent } from './tools/detailrequirements/detailrequirements.component';
// import { DetailRequirementsComponent3 } from './tools/detailrequirements3.0/detailrequirements.component';
import { EditarNorm35Component } from './certificarN35/editar-norm35/editar-norm35.component';

import { CloudComponent } from './tools/cloud/cloud.component';
import { CloudODSComponent } from './tools/cloudODS/cloud.component';
// import { GestorStatusComponent } from './tools/gestUsu/gestor-status/gestor-status.component';

//ACTUALIZAR BD COLABORADORES
import {UpdateEmployeesComponent} from './tools/update-employees/update-employees.component';

//LOG SENDGRID
import { SendgridLogComponent } from './tools/sendgrid-log/sendgrid-log.component';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';
import { AuthAdminGuard } from 'app/auth/auth-admin.guard';
// import { AuthInterceptor } from 'app/auth/auth-interceptor';

import { QuestionsComponent } from './tools/questions/questions.component';
import { Videos35Component } from './tools/videos35/videos35.component';
import { VideosAdministradorComponent } from './tools/videos-administrador/videos-administrador.component';
import { NormatipsComponent } from './tools/normatips/normatips.component';
import { VideosTutorialesComponent } from './resultados/videos-tutoriales/videos-tutoriales.component';
import { LogSistemaComponent } from './tools/log-sistema/log-sistema.component';


const rutas: Routes = [

    // creacion de perfiles
    {
        path     : 'profile-creator',
        component: GestUsuComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },

    // requerimientos tecnicos
    {
        path     : 'requirements/:id',
        component: RequirementsComponent,
        canActivate: [AuthGuard]
    },
    // requerimientos tecnicos detalle Medir_Mejorado
    {
        path     : 'requerimentsLandingmeasurement_t1/requirements-detail',
        component: DetailRequirementsComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'requerimentsLandingcertify_1/requirements-detail',
        component: DetailRequirementsComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'requirements-detail',
        component: DetailRequirementsComponent,
        data : {producto : 'Norma'},
        canActivate: [AuthGuard]
    },

    // creacion de empresa
    // {
    //     path     : 'profile-creator/company/:id',
    //     component: ODSComponent,
    //     canActivate: [AuthGuard, AuthAdminGuard]
    // },
    // {
    //     path     : 'profile-creator/company/edit/:id',
    //     component: EditComponent,
    //     canActivate: [AuthGuard, AuthAdminGuard]
    // },
    {
        path     : 'templates/create',
        component: CreateComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    // consulta de empresas
    {
        path     : 'companies',
        component: TableodsV2Component,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    // detalle de empresas
    {
        path     : 'companies/detail/:id',
        component: DetailComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    {
        path     : 'companies/detail/:id/control-encuesta',
        component: ControlEncuestasComponent,
        canActivate: [AuthGuard, AuthAdminGuard],
    },
    {
        path     : 'companies/detail/:id/:idprod',
        component: VisorCorreosComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },

    /// GESTOR DE ARCHIVOS
    {
        path     : 'companies/detail/:id/:idprod/file-manager',
        component: CloudODSComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    {
        path     : 'file-manager/:id/:idprod',
        component: CloudComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'file-manager',
        component: CloudComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'file-server/:version',
        component: CloudComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'file-server/:version/:id/:idprod',
        component: CloudComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    {
        path     : 'file-server-private/:version/:id/:idprod',
        component: CloudODSComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },

    {
        path     : 'companies/detail/:id/:idprod/:fechaprod/update-employees',
        component: UpdateEmployeesComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    {
        path     : 'companies/detail/:id/:idprod/:fechaprod/:idplantilla/:tipoproducto/sendgrind-log',
        component: SendgridLogComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },

    {
        path     : 'companies/detail/:id/control-encuesta/preview-encuestas',
        component: PreviewEncuestasComponent,
        canActivate: [AuthGuard, AuthAdminGuard],
    },
    // detalle de empresas paquetes
    {
        path     : 'companies/profile/:id',
        component: PaqueteComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    // gestor de status por empresa
    // {
    //     path     : 'companies/status/:id',
    //     component: GestorStatusComponent,
    //     canActivate: [AuthGuard]
    // },
    // creacion de usuario
    {
        path     : 'profile-creator/user',
        component: RegisterUserComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    // configuracion
    {
        path     : 'settings',
        component: ConfigComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    {
        path     : 'settings/collaborators',
        component: UploadDBComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    {
        path     : 'settings/logo',
        component: UploadLogoComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    {
        path     : 'settings/requirements',
        component: UploadFileComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },

    // sin productos
    {
        path     : 'products',
        component: NoProductoComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },
    {
        path     : 'NOM35-EDIT',
        component: EditN35Component,
        canActivate: [AuthGuard]

    },{
        path: "NOM35-EDIT/:dataId",
        component: EditarNorm35Component,
        canActivate: [AuthGuard, AuthAdminGuard]
    },{
        path: "edit-data-norm35-general/:id",
        component: EditarNorm35Component,
        canActivate: [AuthGuard, AuthAdminGuard]
    },{
        path: "preguntas-frecuentes",
        component: QuestionsComponent,
        canActivate: [AuthGuard]
    },{
        path: "videos-institucionales",
        component: Videos35Component,
        canActivate: [AuthGuard]
    },{
        path: "videos-administrador",
        component: VideosAdministradorComponent,
        canActivate: [AuthGuard]
    },{
        path :"norma-tips",
        component: NormatipsComponent,
        canActivate: [AuthGuard]
    },
    {
        path :"videos-tutoriales",
        component: VideosTutorialesComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },

    // sin productos
    {
        path     : 'pruebas',
        component: CardedFullWidth2Component,
        canActivate: [AuthGuard, AuthAdminGuard]
    },

    {
        path     : 'log-sistema',
        component: LogSistemaComponent,
        canActivate: [AuthGuard, AuthAdminGuard] 
    },

];

export const routes = RouterModule.forChild(rutas);
